import React from 'react';
import { Link } from 'react-router-dom';

const TeacherFooter: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div className="text-sm text-gray-500">
            © {new Date().getFullYear()} Lavern Titan. All rights reserved.
          </div>
          
          <div className="flex space-x-6">
            <Link
              to="/privacy"
              className="text-gray-500 hover:text-gray-900 text-sm"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-gray-500 hover:text-gray-900 text-sm"
            >
              Terms of Service
            </Link>
            <Link
              to="/help"
              className="text-gray-500 hover:text-gray-900 text-sm"
            >
              Help Center
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default TeacherFooter; 